import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useGetProjectSurveyTimesetList } from '../../interfaces/survey';
import theme from '../../styles/theme';
import { convertToDayList } from './commonUtil';
import { DesktopDatePicker, DesktopTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';
import { useGetProjectPointSetupTimesetList, useSetProjectSetupTimeTable, useSetProjectTimeInit } from '../../interfaces/point';
import { Button } from '@mui/material';
import SurveyTimesetInfo from './SurveyTimesetInfo';
import { useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from '../../interfaces/modal';

const MainWrap = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    // gap: 1rem;
`;

const PointTimeList =  styled.ul`
    list-style-type: none;
    width: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    cursor: pointer;
    li {
        display: grid;
        grid-template-columns: 0.2rem 10rem 14rem 9rem 0.2rem;
        gap: 1rem;
        font-size: 1rem;
        line-height: 3rem;
        height: 3rem;
    }
    .title {
        border-bottom: 2px solid ${theme.color.black[40]};
    }
    .pts_list {
        border-bottom: 1px solid ${theme.color.black[20]};
    }
    .twoLine {
        white-space: break;
        font-size: 0.8rem !important;
        line-height: 0.8rem;
        margin: auto 0;
    }
    .pts_list:last-child{
        border:0;
    }
`

const PointSetupTime = ({survey, tid}) => {

    const queryClient = useQueryClient();

    const [list, setList] = useState();

    const {data, refetch} = useGetProjectPointSetupTimesetList(tid);
    const {mutate:timeInitMutate} = useSetProjectTimeInit();

    useEffect(()=>{
        refetch();
    },[survey, tid])

    useEffect(()=>{
        setList(data);
    },[data])

    const handleTimeInitClick = useCallback((tid) => {
        const temp = {
            mode: 'SETUP',
            tid:tid
        }
        timeInitMutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'초기화하였습니다.',
                            height:'20vh',
                        }
                    )
                    // onClickAway(false);
                }
            }
            )
    })

    return (
        <MainWrap>
            {/* <div style={{display:'flex',justifyContent:'flex-end'}}>
                <Button variant='contained' onClick={()=>setLoadList(stList)}>조사시간 불러오기</Button>
            </div> */}
            <PointTimeList>
                <li className='title'>
                    <span/>
                    <span>촬영일</span>
                    <span>시간</span>
                    <span/>
                    <span/>
                </li>
            </PointTimeList>
            <div style={{height:'100%',overflow:'auto'}}>
                <PointTimeList>
                    { (list && list.length > 0) && list.map((item,index)=>
                        <ListItem key={index} tid={tid} item={item} />
                    )}
                    <ListItem tid={tid} item={{}} />
                </PointTimeList>
            </div>
            <Button variant='contained' onClick={()=>handleTimeInitClick(tid)}>초기화</Button>
        </MainWrap>
    )
}

const ListItem = ({tid, item}) => {

    const queryClient = useQueryClient();

    const [target, setTarget] = useState();

    const {mutate} = useSetProjectSetupTimeTable();

    useEffect(()=>{
        setTarget(item);
    },[item])
    
    const handleValueChange = (id,val) => {
        const temp  = {...target,[id]:val}
        setTarget(temp);
    }

    const handleAddClick = useCallback((updateItem) => {
        const temp = {
            mode: 'POST',
            ...updateItem,
            // sdate: sdate,
            tid: tid
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'추가하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleUpdateClick = useCallback((updateItem,sid) => {
        const temp = {
            mode: 'PUT',
            ...updateItem,
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'수정하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    const handleDeleteClick = useCallback((updateItem) => {
        const temp = {
            mode: 'DELETE',
            ...updateItem,
            seqArr:JSON.stringify([updateItem.seq])
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:'삭제하였습니다.',
                            height:'20vh',
                        }
                    )
                }
            }
            )
    })

    return (
        <li className='pts_list'>
            <span/>
            <div style={{display:'flex',alignItems:'center'}}>
                <DesktopDatePicker
                    id='addDate'
                    format='YYYY-MM-DD(dd)'
                    // size='small'
                    slotProps={{ textField: { size: 'small'} }}
                    value={(target && target.sdate) ? moment(target.sdate):undefined}
                    onChange={(value)=>handleValueChange('sdate', value.format('HH:mm'))}
                />
            </div>
            <div style={{display:'flex',alignItems:'center'}}>
                <DesktopTimePicker
                    id='stime'
                    format='HH:mm'
                    sx={{width:'8rem'}}
                    // timeSteps={{minutes:time_unit/60}}
                    slotProps={{ textField: { size: 'small'} }}
                    value={(target && target.stime) ? moment(target.sdate +' '+target.stime):undefined}
                    onChange={(value)=>handleValueChange('stime', value.format('HH:mm'))}
                />
                <span>~</span>
                <DesktopTimePicker
                    id='etime'
                    format='HH:mm'
                    sx={{width:'8rem'}}
                    // timeSteps={{minutes:time_unit/60}}
                    slotProps={{ textField: { size: 'small'} }}
                    value={(target && target.etime) ? moment(target.sdate +' '+target.etime):undefined}
                    onChange={(value)=>handleValueChange('etime', value.format('HH:mm'))}
                />
            </div>
            <div>
                {(target && target.seq && target.tid && target.tid > 0) ? 
                    <React.Fragment>
                        <Button variant='contained' onClick={()=>handleUpdateClick(target)}>수정</Button>&nbsp;
                        <Button variant='contained' onClick={()=>handleDeleteClick(target)}>삭제</Button>
                    </React.Fragment>
                    :
                    <Button variant='contained' onClick={()=>handleAddClick(target)}>추가</Button>
                }
            </div>
            <span/>
        </li>
    )
}

export default PointSetupTime;